import { datalabHttp, type TDatalabHttpConfig } from '@dbl/services/common';

import type {
  IAddSqlViewLabelRequest,
  IGetGameTableInfoRequest,
  IGetVirtualTableInfoRequest,
  ISaveAsCustomSqlRequest,
  ISaveCustomSqlTableRequest,
  TGetSqlViewLabelRequest,
} from './types';

/**
 * 获取 SQL View 标签列表，用于标签管理/下拉展示。
 *
 * 原始实现：`src/pages/datalab/services/analysis.ts` -> getSqlViewLabel
 */
export function getSqlViewLabel(
  params: TGetSqlViewLabelRequest,
): Promise<unknown> {
  return datalabHttp({
    url: '/api/v1/datalab/get_table_label_cycle_list',
    method: 'post',
    data: params,
  });
}

/**
 * 添加 SQL View 标签。
 *
 * 原始实现：`src/pages/datalab/services/analysis.ts` -> addSqlViewLabel
 */
export function addSqlViewLabel(
  params: IAddSqlViewLabelRequest,
): Promise<unknown> {
  return datalabHttp({
    url: '/api/v1/datalab/add_table_label_cycle',
    method: 'post',
    data: params,
  });
}

/**
 * SQL View 编辑器：按库/Schema 拉取可选物理表列表。
 *
 * 原始实现：`HeaderData/service.ts` -> getTableInfoSelect
 */
export function getTableInfoSelect(
  params: IGetGameTableInfoRequest,
): Promise<unknown> {
  return datalabHttp({
    url: '/api/v1/datalab/customSql/getGameTableInfo',
    method: 'post',
    data: params,
  });
}

/**
 * 编辑 SQL View 时拉取虚拟表 SQL、库表上下文等信息。
 *
 * 原始实现：`HeaderData/service.ts` -> getVirtualTableInfo
 */
export function getVirtualTableInfo(
  params: IGetVirtualTableInfoRequest,
): Promise<unknown> {
  return datalabHttp({
    url: '/api/v1/datalab/customSql/getVirtualTableInfo',
    method: 'post',
    data: params,
  });
}

/**
 * 创建或更新 SQL View（保存虚拟表）。
 *
 * 原始实现：`HeaderData/service.ts` -> addCustomSqlNext
 */
export function addCustomSqlNext(
  params: ISaveCustomSqlTableRequest,
): Promise<unknown> {
  return datalabHttp({
    url: '/api/v1/datalab/customSql/saveTable',
    method: 'post',
    data: params,
    useCustomTips: true,
  } as TDatalabHttpConfig);
}

/**
 * 另存为 SQL View（不替换当前图表数据源）。
 *
 * 原始实现：`HeaderData/service.ts` -> saveAsCustomSql
 */
export function saveAsCustomSql(
  params: ISaveAsCustomSqlRequest,
): Promise<unknown> {
  return datalabHttp({
    url: '/api/v1/datalab/customSql/save_as',
    method: 'post',
    data: params,
    useCustomTips: true,
  } as TDatalabHttpConfig);
}
